import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getUser = params => common.requestRaw(apiUrl + 'User', params, 'get');
export const addUser = params => common.requestRaw(apiUrl + 'User', params, 'post');
export const updateUser = params => common.requestRaw(apiUrl + 'User', params, 'put');
export const deleteUser = params => common.requestRaw(apiUrl + 'User', params, 'delete');
export const editPassword = params => common.requestRaw(apiUrl + 'User/EditPasswd', params, 'put');
export const initSetting = params => common.requestRaw(apiUrl + 'User/InitSetting', params, 'put');

export const userChangeEmailReSend = params => common.requestRaw(apiUrl + 'User/ChangeEmailReSend', params, 'put');
export const userChangeEmailCancel = params => common.requestRaw(apiUrl + 'User/ChangeEmailCancel', params, 'put');



// WEBPACK FOOTER //
// ./src/script/libs/userLib.js